import React from 'react'
import { AlertDialog, AlertDialogCancel, AlertDialogContent, AlertDialogDescription, AlertDialogFooter, AlertDialogHeader, AlertDialogTitle } from './ui/alert-dialog';
import { Button } from './ui/button';

const ConfirmDialog = ({
    open,
    titleText="Are you sure?",
    descriptionText,
    actionText,
    cancelText="Cancel",
    handleClose,
    confirmAction
}) => {

    return (
        <AlertDialog open={open} onDismiss={handleClose}>
            <AlertDialogContent>
                <AlertDialogHeader>
                    <AlertDialogTitle>{titleText}</AlertDialogTitle>
                </AlertDialogHeader>
                <AlertDialogDescription>
                    {descriptionText}
                </AlertDialogDescription>
                {/* <div className='flex flex-col space-y-4 w-full pt-3 w-full'>
                    Are you sure you want to delete this user?
                </div> */}
                <AlertDialogFooter>
                    <AlertDialogCancel onClick={handleClose}>{cancelText}</AlertDialogCancel>
                    <Button type="button" onClick={confirmAction}>{actionText}</Button>
                </AlertDialogFooter>
            </AlertDialogContent>
        </AlertDialog>
    );
}

export default ConfirmDialog